import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../services/notification.service';
import { CourseService } from '../services/course.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-ask-question',
  templateUrl: './ask-question.component.html',
  styleUrls: ['./ask-question.component.scss']
})
export class AskQuestionComponent implements OnInit {
  askQuestionForm: FormGroup;
  @Input() category_id;
  @Input() course_category;
  @Input() yourQuestion;
  @Input() course_session_id;
  @Input() answer_id;
  @Input() courseId;
  @Input() currentTime: number;
  @Output() closeModelValue = new EventEmitter();
  loader = false;
  selectedPicture: File;
  Week;
  weekIndex;
  selectedVideo: File;
  picName = "No Picture selected";
  videoName = "No Video selected";
  constructor(private fb: FormBuilder, private ns: NotificationService, private courseService: CourseService) { }

  ngOnInit() {
    this.askQuestionForm = this.fb.group({
      subject: ['', Validators.required],
      coins: ['', Validators.required],
      yourQuestion: ['', Validators.required],
      picture: [''],
      video: ['']
    })
  }

  onPicSelected(event) {
    this.selectedPicture = event.target.files[0];
    this.picName = this.selectedPicture.name;
  }

  onVideoSelected(event) {
    this.selectedVideo = event.target.files[0];
    this.videoName = this.selectedVideo.name;
  }

  ngAfterContentInit() {
    this.askQuestionForm.controls['subject'].setValue(this.course_category);
  }

  questionFormSubmit() {
    if (this.askQuestionForm.invalid) {
      this.ns.showNotification("info", "Fill Correct data");
      return;
    }

    if (Number(this.askQuestionForm.value.coins) > Number(localStorage.getItem('coins'))) {
      this.ns.showNotification("info", "You do not have so much coins please check your balance first")
      return false;
    }
    if(Number(this.currentTime) < 1) {
      this.ns.showNotification("info", "You are not able to ask question until the video is not more than 50s..")
      return false;
    }
    this.loader = true;

    if (!this.selectedPicture) {
      this.selectedPicture = null;
    }
    if (!this.selectedVideo) {
      this.selectedVideo = null;
    }
    if(!this.answer_id) {
      this.answer_id = '';
    }

    if(!this.currentTime) {
      this.currentTime = 0;
    } 
    if(!this.courseId) {
      this.courseId = '';
    }
    if(!this.course_session_id) {
      this.course_session_id = '';
    }

    this.courseService.video_question(
      this.askQuestionForm.value,
      this.course_session_id,
      this.courseId,
      this.selectedPicture,
      this.selectedVideo,
      this.category_id,
      this.currentTime,
      this.answer_id,'')
      .pipe(finalize(() => this.loader = false)).subscribe(res => {
        this.ns.showNotification("success", "Question added successfully");
        this.askQuestionForm.reset();
        this.picName = "No Picture selected";
        this.videoName = "No Video selected";
        localStorage.setItem('coins', res.avail_coin);
        this.closeModelValue.emit('closeModel');
      },
        (err) => {
          this.ns.showNotification("error", "Question is not added");
        })
  }

}
